import React from 'react'
import { Helmet } from 'react-helmet-async';
import HeaderOne from "../components/header/HeaderOne";
import Breadcrumb from "./Breadcrumb";
import ServiceEleven from "../components/service/ServiceEleven";




import FooterOne from "../components/footer/FooterOne";

function OurService() {
    const breadcrumbs = [
        { label: 'Home', link: '/' },
        { label: 'Our Services' }
    ];

    const schemaData = {
        "@context": "https://schema.org",
        "@graph": [
            {
                "@type": "WebPage",
                "@id": "https://www.aviteusbusiness.co.uk/services#page",
                "url": "https://www.aviteusbusiness.co.uk/services",
                "name": "Accounting Services Designed for Modern Business",
                "description": "Complete SME accounting across the UK. Bookkeeping, payroll, VAT, tax, advisory, company formation and compliance.",
                "isPartOf": {"@id": "https://www.aviteusbusiness.co.uk/#website"},
                "about": {"@id": "https://www.aviteusbusiness.co.uk/#business"},
                "inLanguage": "en-GB"
            },
            {
                "@type": "Service",
                "@id": "https://www.aviteusbusiness.co.uk/services#bookkeeping",
                "name": "Bookkeeping and Management Accounts",
                "serviceType": "Bookkeeping",
                "provider": {"@id": "https://www.aviteusbusiness.co.uk/#business"},
                "areaServed": {"@type":"Country","name":"United Kingdom"},
                "description": "Accurate books and monthly packs with P&L, balance sheet and cash flow. Bank reconciliations and receipt capture with Xero, Sage or QuickBooks."
            },
            {
                "@type": "Service",
                "@id": "https://www.aviteusbusiness.co.uk/services#payroll",
                "name": "Payroll and Pensions",
                "serviceType": "Payroll",
                "provider": {"@id": "https://www.aviteusbusiness.co.uk/#business"},
                "areaServed": {"@type":"Country","name":"United Kingdom"},
                "description": "Fully managed payroll with RTI submissions, payslips, statutory pay and auto enrolment. HMRC ready records."
            },
            {
                "@type": "Service",
                "@id": "https://www.aviteusbusiness.co.uk/services#tax-vat",
                "name": "Taxation and VAT",
                "serviceType": "Tax and VAT",
                "provider": {"@id": "https://www.aviteusbusiness.co.uk/#business"},
                "areaServed": {"@type":"Country","name":"United Kingdom"},
                "description": "Corporation tax, self assessment, VAT returns and Making Tax Digital compliance, with planning to reduce liabilities lawfully."
            },
            {
                "@type": "Service",
                "@id": "https://www.aviteusbusiness.co.uk/services#advisory",
                "name": "Business Advisory",
                "serviceType": "Advisory",
                "provider": {"@id": "https://www.aviteusbusiness.co.uk/#business"},
                "areaServed": {"@type":"Country","name":"United Kingdom"},
                "description": "Forecasts, budgets, pricing reviews, cost controls and funding readiness. Actions that protect cash and support growth."
            },
            {
                "@type": "Service",
                "@id": "https://www.aviteusbusiness.co.uk/services#formation",
                "name": "Company Formation and Compliance",
                "serviceType": "Company Formation",
                "provider": {"@id": "https://www.aviteusbusiness.co.uk/#business"},
                "areaServed": {"@type":"Country","name":"United Kingdom"},
                "description": "Limited company setup, HMRC registrations, Companies House filings and company secretarial services."
            },
            {
                "@type": "FAQPage",
                "@id": "https://www.aviteusbusiness.co.uk/services#faq",
                "mainEntity": [
                    {
                        "@type": "Question",
                        "name": "Do you work outside London?",
                        "acceptedAnswer": {"@type":"Answer","text":"Yes. We support SMEs and startups across the United Kingdom using secure cloud accounting."}
                    },
                    {
                        "@type": "Question",
                        "name": "Which accounting platforms do you support?",
                        "acceptedAnswer": {"@type":"Answer","text":"We work with Xero, Sage and QuickBooks, including migrations and training."}
                    },
                    {
                        "@type": "Question",
                        "name": "Do you offer fixed fees?",
                        "acceptedAnswer": {"@type":"Answer","text":"Yes. We scope the work clearly and provide fixed monthly pricing."}
                    }
                ]
            },
            {
                "@type": "BreadcrumbList",
                "@id": "https://www.aviteusbusiness.co.uk/services#breadcrumbs",
                "itemListElement": [
                    {"@type":"ListItem","position":1,"name":"Home","item":"https://www.aviteusbusiness.co.uk/"},
                    {"@type":"ListItem","position":2,"name":"Services","item":"https://www.aviteusbusiness.co.uk/services"}
                ]
            }
        ]
    };

    return (
        <div className=''>
            <Helmet>
                <title>Bookkeeping, Payroll, VAT and Tax | Aviteus UK</title>
                <meta name="description" content="Complete accounting for UK SMEs. Bookkeeping, payroll, VAT, tax and advisory with fixed fees and monthly reporting. Book a free consultation." />
                <link rel="canonical" href="https://www.aviteusbusiness.co.uk/services" />
                <script type="application/ld+json">
                    {JSON.stringify(schemaData)}
                </script>
            </Helmet>

            <HeaderOne />
            <Breadcrumb title="Our Services" breadcrumbs={breadcrumbs} />
            <ServiceEleven />


            <FooterOne />

        </div>
    )
}

export default OurService